import { render, staticRenderFns } from "./AppToolbar.vue?vue&type=template&id=764c5022&"
import script from "./AppToolbar.vue?vue&type=script&lang=js&"
export * from "./AppToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../DATA/projects/nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports